import React, { Component } from "react";

class Maintenance extends Component {

  componentDidMount() {
    /** pulisco lo storage per evitare di dover chieder la cancellazione cache */
    let yetTrial = localStorage.getItem("trial-complete");
    localStorage.clear();
    localStorage.setItem("trial-complete", yetTrial);
  }
  renderCircle(
    fillColor, cx, cy, r, stroke, strokeWidth, strokeMiterlimit
  ) {
    return (
      <circle
        fill={fillColor}
        cx={cx}
        cy={cy}
        r={r}
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit={strokeMiterlimit}
      />
    );
  }

  /**
     *
     * @param {*} opacity default "1"
     * @param {*} fillColor
     * @param {*} stroke  default "none"
     * @param {*} strokeMiterlimit default 4
     * @param {*} x1
     * @param {*} y1
     * @param {*} x2
     * @param {*} y2
     * @param {*} strokeWidth default 1
     * @param {*} strokeLinecap default "butt"
     * @param {*} strokeDasharray default ""
     */
  renderLine(
    opacity, fillColor, stroke, strokeMiterlimit, x1, y1, x2, y2, strokeWidth=1, strokeLinecap, strokeDasharray
  ) {
    return (
      <line
        opacity={opacity}
        fill={fillColor}
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit={strokeMiterlimit}
        strokeLinecap={strokeLinecap}
        strokeDasharray={strokeDasharray}
        x1={x1}
        y1={y1}
        x2={x2}
        y2={y2}
      />
    );
  }
  /**
     *
     * @param {*} x
     * @param {*} y
     * @param {*} fillColor
     * @param {*} width
     * @param {*} height
     * @param {*} stroke default "none"
     * @param {*} strokeMiterlimit default 4
     * @param {*} strokeWidth default 1
     */
  renderRect(
    x, y, fillColor, width, height, stroke, strokeMiterlimit, strokeWidth
  ) {
    return (
      <rect
        x={x}
        y={y}
        fill={fillColor}
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit={strokeMiterlimit}
        width={width}
        height={height}
      />
    );
  }

  render() {
    return (
      <div>
        <div
          style={{
            position: "absolute",
            top: "51%",
            margin: "0px 20px",
            fontSize: 28,
            left: "38vw",
            color: "darkred",
            fontWeight: "bold"
          }}
        >
                    SITO IN MANUTENZIONE
        </div>
        <div className="col-md-8 svgcenter">
          <svg
            style={{ height: "100vh" }}
            className="svgcenter"
            x="0px"
            y="0px"
            width="100%"
            viewBox="0 0 526.473 295"
            enableBackground="new 0 0 526.473 295"
          >
            <g
              id="webpages"
              className="mgwebpage"
              data-svg-origin="138.89599609375 24.40399932861328"
              style={{
                transform:
                                    "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -6.21945, 0, 1)"
              }}
            >
              <g>
                <path
                  fill="#F4F4F4"
                  d="M401.896,278.129C401.896,277.03,401.896,277.03,401.896,278.129v12.024c0,1.1-0.9,2.25-2,2.25h-259
                           c-1.1,0-2-1.15-2-2.25v-248c0-1.1,0.9-1.75,2-1.75h259c1.1,0,2,0.65,2,1.75v236.049c0,1.1,0,1.1,0,0V278.129z"
                />
              </g>
              {this.renderRect(
                "138.896", "24.404", "#D8D5DA", 263, 34, "", 4, 1
              )}

              {this.renderCircle(
                "#E9575D", "148.896", "33.74", "2.667", "none", 1, 4
              )}
              {this.renderCircle(
                "#EEC200", "156.896", "33.74", "2.667", "none", 1, 4
              )}
              {this.renderCircle(
                "#6DC14C", "165.896", "33.74", "2.667", "none", 1, 4
              )}
              <path
                fill="#C4C1C6"
                d="M175.896,50.404c0,1.104-0.896,2-2,2h-26c-1.104,0-2-0.896-2-2v-8c0-1.104,0.896-2,2-2h26
                        c1.104,0,2,0.896,2,2V50.404z"
              />
              <path
                fill="#C4C1C6"
                d="M196.896,50.404c0,1.104-0.448,2-1,2h-13c-0.552,0-1-0.896-1-2v-8c0-1.104,0.448-2,1-2h13
                        c0.552,0,1,0.896,1,2V50.404z"
              />
              <path
                fill="#E9E7EC"
                d="M339.896,50.404c0,1.104-0.896,2-2,2h-134c-1.104,0-2-0.896-2-2v-8c0-1.104,0.896-2,2-2h134
                        c1.104,0,2,0.896,2,2V50.404z"
              />
              <path
                fill="#E9E7EC"
                d="M395.896,50.404c0,1.104-0.896,2-2,2h-46c-1.104,0-2-0.896-2-2v-8c0-1.104,0.896-2,2-2h46
                        c1.104,0,2,0.896,2,2V50.404z"
              />
              {this.renderLine(
                "0.1", "none", "#414042", 10, "138.896", "58.904", "401.896", "58.904", 2, "butt", ""
              )}

              {this.renderRect(
                "146.896", "66.404", "#D4D6D8", 16, 16, "", 4, 1
              )}
              {this.renderRect(
                "277.896", "67.404", "#D4D6D8", 34, 5, "", 4, 1
              )}
              {this.renderRect(
                "318.896", "67.404", "#D4D6D8", 34, 5, "", 4, 1
              )}
              {this.renderRect(
                "357.896", "67.404", "#D4D6D8", 34, 5, "", 4, 1
              )}
            </g>
            <polygon
              id="HILL1"
              fill="#E6E7E8"
              stroke="#414042"
              strokeWidth={2}
              strokeMiterlimit={10}
              points="276.896,201.406
                     182.897,292.218 372.23,291.904 "
            />
            <polygon
              id="HILL2"
              fill="#E6E7E8"
              stroke="#414042"
              strokeWidth={2}
              strokeMiterlimit={10}
              points="52.229,292.404
                     135.563,206.782 235.563,292.404 "
            />
            <polygon
              id="HILL3"
              fill="#E6E7E8"
              stroke="#414042"
              strokeWidth={2}
              strokeMiterlimit={10}
              points="131.563,292.361
                     206.896,216.073 296.23,291.904 "
            />
            <g id="house3">
              {this.renderRect(
                "428.896", "238.404", "#FFF9EE", 29, 53, "#414042", 10, 2
              )}
              <polygon
                fill="#FFF9EE"
                stroke="#414042"
                strokeWidth={2}
                strokeMiterlimit={10}
                points="459.063,238.885 443.396,227.404
                        428.896,239.404"
              />
              {this.renderRect(
                "433.396", "242.904", "#FCB832", 7, 7, "#414042", 10, 1
              )}
              {this.renderRect(
                "445.396", "242.904", "#FCB832", 7, 7, "#414042", 10, 1
              )}
              {this.renderRect(
                "433.396", "252.904", "#FCB832", 7, 7, "#414042", 10, 1
              )}
              {this.renderRect(
                "445.396", "252.904", "#FCB832", 7, 7, "#414042", 10, 1
              )}
              {this.renderRect(
                "433.396", "262.904", "#FCB832", 7, 7, "#414042", 10, 1
              )}
              {this.renderRect(
                "445.396", "262.904", "#FCB832", 7, 7, "#414042", 10, 1
              )}
              {this.renderRect(
                "433.396", "272.904", "#FCB832", 7, 7, "#414042", 10, 1
              )}
              {this.renderRect(
                "445.396", "272.904", "#FCB832", 7, 7, "#414042", 10, 1
              )}
              {this.renderRect(
                "433.396", "282.904", "#FCB832", 7, 7, "#414042", 10, 1
              )}
              {this.renderRect(
                "445.396", "282.904", "#FCB832", 7, 7, "#414042", 10, 1
              )}
            </g>
            <g id="tower3">
              {this.renderRect(
                "375.896", "170.404", "#FEE2AE", 52, 102, "#414042", 10, 2
              )}
              {this.renderRect(
                "371.896", "271.404", "#E6E7E8", 61, 6, "#414042", 10, 2
              )}
              {this.renderRect(
                "376.896", "277.404", "#E6E7E8", 52, 14, "#414042", 10, 2
              )}
              {this.renderLine(
                "1", "none", "#414042", 10, "388.896", "169.404", "388.896", "271.404", 2, "butt", ""
              )}
              {this.renderLine(
                "1", "none", "#414042", 10, "402.896", "169.404", "402.896", "271.404", 2, "butt", ""
              )}
              {this.renderLine(
                "1", "none", "#414042", 10, "415.896", "169.404", "415.896", "271.404", 2, "butt", ""
              )}
              {this.renderLine(
                "1", "none", "#414042", 10, "376.896", "205.404", "428.896", "205.404", 2, "butt", ""
              )}
              {this.renderLine(
                "1", "none", "#414042", 10, "376.896", "241.404", "428.896", "241.404", 2, "butt", ""
              )}
              {this.renderRect(
                "371.896", "163.404", "#E6E7E8", 61, 7, "#414042", 10, 2
              )}
              {this.renderRect(
                "377.896", "157.404", "#E6E7E8", 47, 6, "#414042", 10, 2
              )}
              <polyline
                fill="#E6E7E8"
                stroke="#414042"
                strokeWidth={2}
                strokeMiterlimit={10}
                points="415.896,291.404 415.896,283.404 387.896,283.404 387.896,291.404"
              />
              {this.renderLine(
                "1", "#E6E7E8", "#414042", 10, "401.896", "283.404", "401.896", "291.404", 2, "butt", ""
              )}
            </g>
            <g id="tower1">
              {this.renderRect(
                "335.896", "181.404", "#F0F1F1", 44, 110, "#414042", 10, 2
              )}
              {this.renderRect(
                "340.896", "184.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "187.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "190.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "193.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "196.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "199.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "202.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "205.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "208.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "211.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "214.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "217.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "220.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "223.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "226.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "229.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "232.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "235.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "238.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "241.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "244.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "247.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "250.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "253.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "256.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "259.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "262.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "265.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "268.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "271.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "274.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "277.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "280.404", "#414042", 34, 2, "", 4, 1
              )}
              {this.renderRect(
                "340.896", "165.404", "#414042", 34, 2, "", 4, 1
              )}
            </g>
            <g id="tower2">
              {this.renderRect(
                "293.896", "211.404", "#FDD484", 42, 80, "#414042", 10, 2
              )}
              {this.renderRect(
                "294.896", "215.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "218.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "221.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "224.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "227.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "230.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "233.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "236.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "239.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "242.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "245.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "248.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "251.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "254.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "257.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "260.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "263.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "266.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "269.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "272.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "275.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "278.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "281.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "284.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "294.896", "287.404", "#414042", 41, 1, "", 4, 1
              )}
              {this.renderRect(
                "308.396", "213.904", "#FFFFFF", 19, 75, "#414042", 10, 1
              )}
              {this.renderRect(
                "310.396", "216.904", "#FFFFFF", 15, 5, "#414042", 10, 1
              )}
              {this.renderRect(
                "310.396", "224.904", "#FFFFFF", 15, 5, "#414042", 10, 1
              )}
              {this.renderRect(
                "310.396", "232.904", "#FFFFFF", 15, 5, "#414042", 10, 1
              )}
              {this.renderRect(
                "310.396", "240.904", "#FFFFFF", 15, 5, "#414042", 10, 1
              )}
              {this.renderRect(
                "310.396", "248.904", "#FFFFFF", 15, 5, "#414042", 10, 1
              )}
              {this.renderRect(
                "310.396", "256.904", "#FFFFFF", 15, 5, "#414042", 10, 1
              )}
              {this.renderRect(
                "310.396", "264.904", "#FFFFFF", 15, 5, "#414042", 10, 1
              )}
              {this.renderRect(
                "310.396", "272.904", "#FFFFFF", 15, 5, "#414042", 10, 1
              )}
              {this.renderRect(
                "310.396", "279.904", "#FFFFFF", 15, 5, "#414042", 10, 1
              )}
              <polygon
                fill="#E6E7E8"
                stroke="#414042"
                strokeWidth={2}
                strokeMiterlimit={10}
                points="291.396,210.404 335.896,210.404
                        335.896,196.404 292.396,196.404 	"
              />
            </g>
            <g id="house">
              {this.renderRect(
                "228.896", "269.404", "#E6E7E8", 83, 23, "#414042", 10, 2
              )}
              {this.renderRect(
                "226.896", "291.404", "#413F43", 89, 2, "", 4, 1
              )}
              {this.renderRect(
                "263.896", "274.404", "#FDC65E", 13, 18, "#413F43", 10, 2
              )}
              {this.renderRect(
                "234.896", "274.404", "#FDC65E", 22, 9, "#413F43", 10, 2
              )}
              {this.renderLine(
                "1", "#FDC65E", "#413F43", 10, "242.896", "274.404", "242.896", "283.404", 2, "butt", ""
              )}
              {this.renderLine(
                "1", "#FDC65E", "#413F43", 10, "234.896", "280.404", "256.896", "280.404", 2, "butt", ""
              )}
              {this.renderRect(
                "284.896", "274.404", "#FDC65E", 21, 10, "#413F43", 10, 2
              )}
              {this.renderLine(
                "1", "#FDC65E", "#413F43", 10, "292.896", "274.404", "292.896", "284.404", 2, "butt", ""
              )}
              {this.renderLine(
                "1", "#FDC65E", "#413F43", 10, "284.896", "280.404", "305.896", "280.404", 2, "butt", ""
              )}
              {this.renderRect(
                "226.896", "264.404", "#E6E7E8", 87, 4, "#414042", 10, 2
              )}
              <polygon
                fill="#FDC65E"
                stroke="#413F43"
                strokeWidth={2}
                strokeMiterlimit={10}
                points="229.521,264.743 241.934,250.404
                        300.896,250.404 314.146,265.029 	"
              />
              <polygon
                fill="#E6E7E8"
                stroke="#414042"
                strokeWidth={2}
                strokeMiterlimit={10}
                points="271.396,252.593 250.146,267.404
                        291.896,267.404 	"
              />
            </g>
            <g
              id="SUN"
              className="mgrotate"
              data-svg-origin="267.7550048828125 104.26200485229492"
              style={{
                transformOrigin: "0px 0px 0px",
                transform:
                                    "matrix3d(0.957117, -0.2897, 0, 0, 0.2897, 0.957117, 0, 0, 0, 0, 1, 0, -18.7227, 82.0397, 0, 1)"
              }}
            >
              {this.renderCircle(
                "#FCB832", "268.146", "103.904", "16.75", "#414042", 2, 10
              )}
              <g>
                {this.renderLine(
                  "1", "none", "#414042", 10, "280.542", "72.652", "273.954", "86.128", 2, "butt", ""
                )}
                {this.renderLine(
                  "1", "none", "#414042", 10, "281.517", "81.475", "277.66", "87.94", 2, "butt", ""
                )}
              </g>
              <g>
                {this.renderLine(
                  "1", "none", "#414042", 10, "267.078", "70.398", "266.996", "85.398", 2, "butt", ""
                )}
                {this.renderLine(
                  "1", "none", "#414042", 10, "271.787", "77.922", "271.121", "85.42", 2, "butt", ""
                )}
              </g>
              <g>
                {this.renderLine(
                  "1", "none", "#414042", 10, "298.328", "89.088", "284.391", "94.641", 2, "butt", ""
                )}
                {this.renderLine(
                  "1", "none", "#414042", 10, "293.118", "96.278", "285.918", "98.474", 2, "butt", ""
                )}
              </g>
              <g>
                {this.renderLine(
                  "1", "none", "#414042", 10, "289.87", "78.372", "279.729", "89.427", 2, "butt", ""
                )}
                {this.renderLine(
                  "1", "none", "#414042", 10, "288.301", "87.109", "282.769", "92.215", 2, "butt", ""
                )}
              </g>
              <g>
                {this.renderLine(
                  "1", "none", "#414042", 10, "300.81", "113.607", "286.71", "108.488", 2, "butt", ""
                )}
                {this.renderLine(
                  "1", "none", "#414042", 10, "292.14", "115.513", "285.302", "112.364", 2, "butt", ""
                )}
              </g>
              <g>
                {this.renderLine(
                  "1", "none", "#414042", 10, "301.621", "99.98", "286.697", "101.491", 2, "butt", ""
                )}
                {this.renderLine(
                  "1", "none", "#414042", 10, "294.639", "105.461", "287.113", "105.595", 2, "butt", ""
                )}
              </g>
              <g>
                {this.renderLine(
                  "1", "none", "#414042", 10, "286.356", "133.038", "279.354", "119.77", 2, "butt", ""
                )}
                {this.renderLine(
                  "1", "none", "#414042", 10, "278.654", "128.621", "275.706", "121.696", 2, "butt", ""
                ) }
              </g>
              <g>
                {this.renderLine(
                  "1", "none", "#414042", 10, "296.114", "123.489", "284.044", "114.581", 2, "butt", ""
                ) }
                {this.renderLine(
                  "1", "none", "#414042", 10, "287.259", "122.858", "281.594", "117.9", 2, "butt", ""
                )}
              </g>
              <g>
                {this.renderLine(
                  "1", "none", "#414042", 10, "261.074", "138.126", "265.178", "123.698", 2, "butt", ""
                ) }
                {this.renderLine(
                  "1", "none", "#414042", 10, "258.555", "129.615", "261.21", "122.569", 2, "butt", ""
                )}
              </g>
              <g>
                {this.renderLine(
                  "1", "none", "#414042", 10, "274.725", "137.966", "272.155", "123.187", 2, "butt", ""
                )}
                {this.renderLine(
                  "1", "none", "#414042", 10, "268.761", "131.392", "268.091", "123.894", 2, "butt", ""
                ) }
              </g>
              <g>
                {this.renderLine(
                  "1", "none", "#414042", 10, "240.665", "125.09", "253.4", "117.163", 2, "butt", ""
                )}
                {this.renderLine(
                  "1", "none", "#414042", 10, "244.523", "117.093", "251.22", "113.661", 2, "butt", ""
                )}
              </g>
              <g>
                {this.renderLine(
                  "1", "none", "#414042", 10, "250.882", "134.144", "258.911", "121.472", 2, "butt", ""
                )}
                {this.renderLine(
                  "1", "none", "#414042", 10, "250.882", "125.267", "255.425", "119.265", 2, "butt", ""
                )}
              </g>
              <g>
                {this.renderLine(
                  "1", "none", "#414042", 10, "233.889", "101.397", "248.671", "103.944", 2, "butt", ""
                )}
                {this.renderLine(
                  "1", "none", "#414042", 10, "242.085", "97.989", "249.372", "99.88", 2, "butt", ""
                )}
              </g>
              <g>
                {this.renderLine(
                  "1", "none", "#414042", 10, "235.5", "114.953", "249.92", "110.829", 2, "butt", ""
                )}
                {this.renderLine(
                  "1", "none", "#414042", 10, "241.402", "108.324", "248.786", "106.862", 2, "butt", ""
                )}
              </g>
              <g>
                {this.renderLine(
                  "1", "none", "#414042", 10, "244.682", "79.718", "253.918", "91.54", 2, "butt", ""
                )}
                {this.renderLine(
                  "1", "none", "#414042", 10, "253.044", "82.705", "257.169", 89, 2, "butt", ""
                )}
              </g>
              <g>
                {this.renderLine(
                  "1", "none", "#414042", 10, "236.765", "90.84", "250.218", "97.476", 2, "butt", ""
                )}
                {this.renderLine(
                  "1", "none", "#414042", 10, "245.592", "89.897", "252.044", "93.777", 2, "butt", ""
                )}
              </g>
              <g>
                {this.renderLine(
                  "1", "none", "#414042", 10, "254.412", "72.901", "259.458", "87.029", 2, "butt", ""
                )}
                {this.renderLine(
                  "1", "none", "#414042", 10, "261.409", "78.368", "263.344", "85.642", 2, "butt", ""
                )}
              </g>
            </g>
            {this.renderLine(
              "1", "none", "#414042", 10, "110.896", "215.404", "110.896", "292.404", 2, "butt", ""
            )}
            {this.renderLine(
              "1", "none", "#414042", 10, "71.896", "243.404", "71.896", "292.404", 2, "butt", ""
            )}
            {this.renderLine(
              "1", "none", "#414042", 10, "34.896", "239.404", "34.896", "293.404", 2, "butt", ""
            )}
            <g
              id="windlill"
              className="windmill"
              data-svg-origin="32.83300018310547 240.40401458740234"
              style={{
                transformOrigin: "0px 0px 0px",
                transform:
                                    "matrix3d(-0.789191, 0.614147, 0, 0, -0.614147, -0.789191, 0, 0, 0, 0, 1, 0, 206.388, 409.964, 0, 1)"
              }}
            >

              <ellipse
                transform="matrix(-0.9384 -0.3455 0.3455 -0.9384 -5.2803 454.8665)"
                fill="#E6E7E8"
                stroke="#414042"
                strokeMiterlimit={10}
                cx="37.896"
                cy="227.904"
                rx="2.321"
                ry="11.499"
              />
              <ellipse
                transform="matrix(0.7324 -0.6809 0.6809 0.7324 -159.0946 95.443)"
                fill="#E6E7E8"
                stroke="#414042"
                strokeMiterlimit={10}
                cx="41.877"
                cy="250.125"
                rx="2.321"
                ry="11.499"
              />
              <ellipse
                transform="matrix(0.2163 0.9763 -0.9763 0.2163 252.8175 170.7206)"
                fill="#E6E7E8"
                stroke="#414042"
                strokeMiterlimit={10}
                cx="20.072"
                cy="242.833"
                rx="2.321"
                ry="11.499"
              />
              {this.renderCircle(
                "#414042", "33.21", "239.804", "2.687", "none", 1, 4
              )}

            </g>
            <g
              id="windlill_1_"
              className="windmill"
              data-svg-origin="71.83300018310547 244.40401458740234"
              style={{
                transformOrigin: "0px 0px 0px",
                transform:
                                    "matrix3d(-0.789191, 0.614147, 0, 0, -0.614147, -0.789191, 0, 0, 0, 0, 1, 0, 278.623, 393.169, 0, 1)"
              }}
            >
              <ellipse
                transform="matrix(-0.677 -0.736 0.736 -0.677 -35.8082 455.4767)"
                fill="#E6E7E8"
                stroke="#414042"
                strokeMiterlimit={10}
                cx="82.047"
                cy="235.596"
                rx="2.321"
                ry="11.5"
              />
              <ellipse
                transform="matrix(0.9625 -0.2712 0.2712 0.9625 -66.9182 30.0959)"
                fill="#E6E7E8"
                stroke="#414042"
                strokeMiterlimit={10}
                cx="75.438"
                cy="257.182"
                rx="2.321"
                ry="11.499"
              />
              <ellipse
                transform="matrix(-0.2536 0.9673 -0.9673 -0.2536 307.2939 244.358)"
                fill="#E6E7E8"
                stroke="#414042"
                strokeMiterlimit={10}
                cx="59.371"
                cy="240.736"
                rx="2.321"
                ry="11.499"
              />
              {this.renderCircle(
                "#414042", "72.442", "244.042", "2.687", "none", 1, 4
              ) }
            </g>
            <g
              id="windlill_2_"
              className="windmill"
              data-svg-origin="110.83300399780273 222.4040069580078"
              style={{
                transformOrigin: "0px 0px 0px",
                transform:
                                    "matrix3d(-0.789191, 0.614147, 0, 0, -0.614147, -0.789191, 0, 0, 0, 0, 1, 0, 334.89, 329.856, 0, 1)"
              }}
            >
              <ellipse
                transform="matrix(-0.0679 -0.9977 0.9977 -0.0679 -88.6628 361.0031)"
                fill="#E6E7E8"
                stroke="#414042"
                strokeMiterlimit={10}
                cx="124.311"
                cy="221.92"
                rx="2.321"
                ry="11.5"
              />
              <ellipse
                transform="matrix(0.9206 0.3905 -0.3905 0.9206 100.0007 -22.6286)"
                fill="#E6E7E8"
                stroke="#414042"
                strokeMiterlimit={10}
                cx="105.653"
                cy="234.628"
                rx="2.321"
                ry="11.499"
              />
              <ellipse
                transform="matrix(-0.8029 0.5961 -0.5961 -0.8029 312.6547 320.1146)"
                fill="#E6E7E8"
                stroke="#414042"
                strokeMiterlimit={10}
                cx="103.405"
                cy="211.747"
                rx="2.321"
                ry="11.499"
              />
              {this.renderCircle(
                "#414042", "111.534", "222.502", "2.687"
              )}
            </g>
            <g id="tree">
              <g id="tree1">
                {this.renderCircle(
                  "#30CCA7", "135.396", "269.417", "10.281", "#414042", 1, 10
                )}
                {this.renderLine(
                  "1", "#30CCA7", "#414042", 10, "135.396", "269.404", "135.396", "292.404", 1, "butt", ""
                )}
              </g>
              <g id="tree1_1_">
                {this.renderCircle(
                  "#30CCA7", "182.396", "269.417", "10.281", "#414042", 1, 10
                )}
                {this.renderLine(
                  "1", "#30CCA7", "#414042", 10, "182.396", "269.404", "182.396", "292.404", 1, "butt", ""
                )}
              </g>
              <g id="tree1_2_">
                {this.renderCircle(
                  "#30CCA7", "319.396", "270.417", "10.281", "#414042", 1, 10
                )}
                {this.renderLine(
                  "1", "#30CCA7", "#414042", 10, "319.396", "270.404", "319.396", "293.404", 1, "butt", ""
                )}
              </g>
              <g id="tree1_3_">
                {this.renderCircle(
                  "#30CCA7", "347.396", "270.417", "10.281", "#414042", 1, 10
                )}
                {this.renderLine(
                  "1", "#30CCA7", "#414042", 10, "347.396", "270.404", "347.396", "293.404", 1, "butt", ""
                )}
              </g>
              <g id="tree1_4_">
                {this.renderCircle(
                  "#30CCA7", "416.396", "269.417", "10.281", "#414042", 1, 10
                )}
                {this.renderLine(
                  "1", "#30CCA7", "#414042", 10, "416.396", "269.404", "416.396", "292.404", 1, "butt", ""
                )}
              </g>
              <g id="tree1_5_">
                {this.renderCircle(
                  "#30CCA7", "504.396", "269.417", "10.281", "#414042", 1, 10
                )}
                {this.renderLine(
                  "1", "#30CCA7", "#414042", 10, "504.396", "269.404", "504.396", "292.404", 1, "butt", ""
                )}
              </g>
              <g id="tree2">
                {this.renderLine(
                  "1", "none", "#414042", 10, "159.396", "248.404", "159.396", "291.404", 1, "butt", ""
                )}
                {this.renderCircle(
                  "#30CCA7", "159.146", "259.135", "6.25", "#414042", 1, 10
                )}
                {this.renderCircle(
                  "#30CCA7", "159.146", "244.135", "6.25", "#414042", 1, 10
                )}
                {this.renderCircle(
                  "#30CCA7", "159.146", "274.135", "6.25", "#414042", 1, 10
                )}
              </g>
              <g id="tree2_1_">
                {this.renderLine(
                  "1", "none", "#414042", 10, "230.396", "249.404", "230.396", "292.404", 1, "butt", ""
                )}
                {this.renderCircle(
                  "#30CCA7", "230.146", "260.135", "6.25", "#414042", 1, 10
                )}
                {this.renderCircle(
                  "#30CCA7", "230.146", "245.135", "6.25", "#414042", 1, 10
                )}
                {this.renderCircle(
                  "#30CCA7", "230.146", "275.135", "6.25", "#414042", 1, 10
                )}
              </g>
              <g id="tree2_2_">
                {this.renderLine(
                  "1", "none", "#414042", 10, "369.396", "250.404", "369.396", "293.404", 2, "butt", ""
                )}
                {this.renderCircle(
                  "#30CCA7", "369.146", "261.135", "6.25", "#414042", 1, 10
                )}
                {this.renderCircle(
                  "#30CCA7", "369.146", "246.135", "6.25", "#414042", 1, 10
                )}
                {this.renderCircle(
                  "#30CCA7", "369.146", "276.135", "6.25", "#414042", 1, 10
                )}
              </g>
              <g id="tree2_3_">
                {this.renderLine(
                  "1", "none", "#414042", 10, "483.396", "249.404", "483.396", "292.404", 2, "butt", ""
                )}
                {this.renderCircle(
                  "#30CCA7", "483.146", "260.135", "6.25", "#414042", 1, 10
                )}
                {this.renderCircle(
                  "#30CCA7", "483.146", "245.135", "6.25", "#414042", 1, 10
                ) }
                {this.renderCircle(
                  "#30CCA7", "483.146", "275.135", "6.25", "#414042", 1, 10
                ) }
              </g>
              <g id="tree3">
                <path
                  fill="#30CCA7"
                  stroke="#414042"
                  strokeMiterlimit={10}
                  d="M215.396,272.904c0,3.313-2.687,6-6,6h-5c-3.313,0-6-2.687-6-6
                           v-14c0-3.313,2.687-6,6-6h5c3.313,0,6,2.687,6,6V272.904z"
                />
                {this.renderLine(
                  "1", "none", "#414042", 10, "206.396", "266.404", "206.396", "293.404", 2, "butt", ""
                )}
              </g>
              <g id="tree3_1_">
                <path
                  fill="#30CCA7"
                  stroke="#414042"
                  strokeMiterlimit={10}
                  d="M472.396,271.904c0,3.313-2.687,6-6,6h-5c-3.313,0-6-2.687-6-6
                           v-14c0-3.313,2.687-6,6-6h5c3.313,0,6,2.687,6,6V271.904z"
                />
                {this.renderLine(
                  "1", "none", "#414042", 10, "463.396", "265.404", "463.396", "292.404", 2, "butt", ""
                )}
              </g>
            </g>
            <g id="WIND">
              <g>
                <g
                  className="wind"
                  style={{ opacity: "0.0812221" }}
                >
                  {this.renderLine(
                    "1", "none", "#545455", 10, "32.896", "106.404", "52.896", "106.404", 2, "round", ""
                  )}
                  {this.renderLine(
                    "1", "none", "#545455", 10, "53.896", "106.404", "87.896", "106.404", 2, "round", "10,19,1,10"
                  )}
                  {this.renderLine(
                    "1", "none", "#545455", 10, "92.896", "106.404", "112.896", "106.404", 2, "round", ""
                  )}
                </g>
              </g>
              <g>
                <g
                  className="wind1"
                  style={{ opacity: "0.000413295" }}
                >
                  {this.renderLine(
                    "1", "none", "#545455", 10, "106.896", "144.404", "126.896", "144.404", 2, "round", ""
                  ) }
                  {this.renderLine(
                    "1", "none", "#545455", 10, "126.896", "144.404", "147.896", "144.404", 2, "round", "9,7,0,9"
                  ) }
                  {this.renderLine(
                    "1", "none", "#545455", 10, "151.896", "144.404", "171.896", "144.404", 2, "round", ""
                  )}
                </g>
              </g>
              <g>
                <g
                  className="wind1"
                  style={{ opacity: "0.000413295" }}
                >
                  {this.renderLine(
                    "1", "none", "#545455", 10, "337.896", "112.404", "357.896", "112.404", 2, "round", ""
                  )}
                  {this.renderLine(
                    "1", "none", "#545455", 10, "358.896", "112.404", "407.896", "112.404", 2, "round", "21,17,1,21"
                  )}
                  {this.renderLine(
                    "1", "none", "#545455", 10, "417.896", "112.404", "437.896", "112.404", 2, "round", ""
                  )}
                </g>
              </g>
              <g>
                <g
                  className="wind"
                  style={{ opacity: "0.0812221" }}
                >
                  {this.renderLine(
                    "1", "none", "#545455", 10, "326.896", "148.404", "346.896", "148.404", 2, "round", ""
                  )}
                  {this.renderLine(
                    "1", "none", "#545455", 10, "346.896", "148.404", "370.896", "148.404", 2, "round","10,8,0,10"
                  )}
                  {this.renderLine(
                    "1", "none", "#545455", 10, "375.896", "148.404", "395.896", "148.404", 2, "round", ""
                  )}
                </g>
              </g>
              <g>
                <g
                  className="wind1"
                  style={{ opacity: "0.000413295" }}
                >
                  {this.renderLine(
                    "1", "none", "#545455", 10, "448.896", "156.404", "468.896", "156.404", 2, "round", ""
                  )}
                  {this.renderLine(
                    "1", "none", "#545455", 10, "468.896", "156.404", "471.896", "156.404", 2, "round", "1,1,0,1"
                  )}
                  {this.renderLine(
                    "1", "none", "#545455", 10, "472.896", "156.404", "492.896", "156.404", 2, "round", ""
                  )}
                </g>
              </g>
              <g>
                <g
                  className="wind"
                  style={{ opacity: "0.0812221" }}
                >
                  {this.renderLine(
                    "1", "none", "#545455", 10, "181.896", "183.404", "201.896", "183.404", 2, "round", ""
                  )}
                  {this.renderLine(
                    "1", "none", "#545455", 10, "201.896", "183.404", "229.896", "183.404", 2, "round", "12,9,0,12"
                  )}
                  {this.renderLine(
                    "1", "none", "#545455", 10, "235.896", "183.404", "255.896", "183.404", 2
                  )}
                </g>
              </g>
            </g>
            {this.renderLine(
              "1", "none", "#414042", 10, "21.896", "292.404", "514.896", "292.404", 2
            )}
          </svg>
        </div>
      </div>
    );
  }
}
export default Maintenance;